<template>
  <!-- BEGIN: Content-->
  <div>
    <CommonTableV2
        :url="url"
        :tableHeaderValues="tableHeaderValues"
        :actions="actions"
        :deleteActions="deleteActions"
        :mutedData="mutedData"
        :storageKey="storageKey"
        :externalTotalRecord="externalTotalRecord"
        :filteredData="filteredData"
        :showPerPage = true
        :tableAccordian="transactionChargesTable"
        :exportData="exportData"
        :hidePdfExportButton="true"
        @getFullResponse="getFullResponse"
        :hideAllPerPage="true"
    />
    <TransactionChargesModal :show="showChargesModal" :data="chargesData"
                                  @hide="showChargesModal = false"

    />


    <RefundModal :show="showRefundModal" :transactionId="transactionId"
                 :refundInitialAmount="refundInitialAmount"
                 @hide="showRefundModal = false"></RefundModal>

    <CardDetailsModal :show="showCardModal" :transactionId="transactionId"

                 @hide="showCardModal = false"></CardDetailsModal>

    <DirectCreditModal :show="showDirectCreditModal" :transactionId="transactionId"
                 :refundInitialAmount="refundInitialAmount"
                 @hide="showDirectCreditModal = false"></DirectCreditModal>

    <ExchangeDetailModal
      :exchangeData="exchangeData"
      :show="showExchangeData"
      @hide="showExchangeData = false"
    ></ExchangeDetailModal>

    <ProcessModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to proceed?"
                  title="Check Gateway Settlement Status"
                  :loader="confirmationModalLoader"
                  @hide="showConfirmationModal = false"></ProcessModal>

  </div>
  <!-- END: Content-->
</template>

<script>
import TransactionChargesModal from "@/pages/dashboard/transactions/TransactionChargesModal";
import RefundModal from "@/pages/dashboard/transactions/RefundModal";
import ExchangeDetailModal from "@/pages/dashboard/transactions/ExchangeDetailModal";
import DirectCreditModal from "@/pages/dashboard/transactions/DirectCreditModal";
import CardDetailsModal from "./CardDetailsModal";
import CommonTableV2 from "@/components/dashboard/common/CommonTableV2.vue";

export default {
  props:['filter'],
  components:{
    CommonTableV2,
    CardDetailsModal,
    TransactionChargesModal,
    RefundModal,
    ExchangeDetailModal,
    DirectCreditModal

  },
  mounted() {
    localStorage.setItem("url", "v1/get-transaction");
    this.checkDataInStore('v1/get-transaction')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      showConfirmationModal: false,
      showCardModal: false,
      confirmationModalLoader: false,
      exchangeData:{},
      showExchangeData:false,
      currentPage: 1,
      showRefundModal:false,
      showDirectCreditModal:false,
      transactionId:'',
      exportData:{
        cta: (exportType) => {
          this.$emit('exportData',exportType)
        }
      },
      showChargesModal: false,
      chargesData: [],
      url: "v1/get-transaction",
      storageKey: "preauth_transactions",
      isDefault: false,
      tableHeaderValues: [
        {
          title: "Transaction Id",
          valueKey: "uuid",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value) {
              if(row.application == 'DIRECT_API_PAYMENT'){
                html = `
                <div class="row">
                    <div class="col-12 text-center">
                        <div class=""><span class="text-primary font-weight-bolder" style="cursor: pointer">${value}</span></div>
                        <div class="badge badge-light-info mt-1">Direct Api Payment</div>
                    </div>
                </div>
                `

              }else{
                html = `<span class="text-primary font-weight-bolder" style="cursor: pointer">${value}</span>`
              }

              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.copyText(row.uuid);
            this.$router.push({name: 'transactions-detail',params: {id:row.uuid}})
          }
        },
        {
          title: "Gateway Reference Id",
          valueKey: "gateway_reference_id",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-info" title="Click To Copy" style="cursor: pointer">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            if(row.gateway_reference_id){
              this.copyText(row.gateway_reference_id);
            }

          }
        },
        {
          title: "Gateway Settlement Status",
          valueKey: "gateway_reference_id",
          html: true,
          alter: (value,row) => {
            var html = "N/A";
            if(typeof(row.gw_settlement_status) != 'undefined'){
              if (row.gw_settlement_status != null) {
                var updated_at = ''
                if(row.gw_settlement_status_update_at != null){
                  updated_at = `<div class="" ><span class="badge-light-success badge ">${this.customFormatDateTime(row.gw_settlement_status_update_at)}</span></div>`
                }
                html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class=""><span class="badge-light badge text-primary">${row.gw_settlement_status==1?"Transmitted":"Not Transmitted"}</span></div>
                        ${updated_at}
                    </div>
                </div>
                `

              }
            }
            return html;
          },

        },
        {
          title: "Reference Id",
          valueKey: "reference_id",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-dark" title="Click To Copy"  style="cursor: pointer">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            if(row.reference_id){
              this.copyText(row.reference_id);
            }

          }
        },
        {
          title: "Sender Account Number",
          valueKey: "sender_account_number",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Sender Account Title",
          valueKey: "sender_account_title",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`;
            }
          }
        },
        {
          title: "Receiver Account Number",
          valueKey: "receiver_account_number",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Reciever Account Title",
          valueKey: "receiver_account_title",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-info">${value}</a>`;
            }
          }
        },
        {
          title: "Payment Method",
          valueKey: "payment_method.name",
          html: true,
          alter: (value,row) => {
            if (!value) {
              return "-";
            } else {
              let applePay = ''
              if(row?.payment_method_type == 2){
                applePay = `<div class="row justify-content-center">   <img width="45" height="45" src="${this.publicPath}app-assets/images/methods/Apple_Pay-Logo.wine.svg"></div>`
              }
              else if(row?.payment_method_type == 3){
                applePay = `<div class="row justify-content-center"><img width="45" height="45" src="${this.publicPath}app-assets/images/methods/Google_Pay-Logo.wine.svg" ></div>`
              }
              return `<div class="grid">
              <div class="row"><div class="badge badge-light-primary mt-sm-1">${value}</div></div>
              ${applePay}
              </div>`;
            }
          }
        },
        {
          title: "Channel",
          valueKey: "channel",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              const name = value.name;
              const maxLength = 16;
              const displayName = name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
              return `<span class="badge text-dark" title="${name}">${displayName}</span>`;
            }
          }
        },
        {
          title: 'Currency',
          valueKey: 'currency.code',
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value) {
              if(row.exchange_details){
                if(row.transaction_type_id == 4){
                  html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class="badge-success badge badge-glow">${value}</div>
                        <div class="badge badge-light-primary mt-1">${'exchange with '+ row.exchange_details.to_currency}</div>
                    </div>
                </div>
                `

                }else{
                  html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class="badge-success badge badge-glow">${value}</div>
                        <div class="badge badge-light-primary mt-1">${'processed in '+ row.exchange_details.to_currency}</div>
                    </div>
                </div>
                `
                }


              }else{
                html = `<div class="row">
                    <div class="col-12 ">
                        <div class="badge-success badge badge-glow">${value}</div>

                    </div>
                </div>`
              }

              return html;
            } else {
              html = "-";
              return html;
            }
          },
        },
        {
          title: 'Actual Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if (row.total_amount != value)
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(row.total_amount / 100).toFixed(this.amountDecimalPlaces))}</div>`
            else
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(value/100).toFixed(this.amountDecimalPlaces))}</div>`


            return  html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value,row) => {
            var html=''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return  html
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value,row) => {
            var html=''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return  html

          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if (row.transaction_type_id == 6) {
              html = ` <div  class=" font-weight-bolder text-danger">- ${this.modifyAmount(parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces))}</div>`
              return html
            }
            if (row.total_amount != value)

              html = ` <div  class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value)/100).toFixed(this.amountDecimalPlaces))}</div>`
            else
              html = ` <div  class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value-row.vat-row.fee)/100).toFixed(this.amountDecimalPlaces))}</div>`

            return  html


          }
        },
        {
          title: "Processed Amount",
          valueKey: "uuid",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (row.exchange_details) {
              html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class=""><span class="font-weight-bolder  text-primary">${this.modifyAmount(this.calculateProcessedAndExchangeRateAmountForList(row))}</span></div>
                        <div class=""><span class="badge-light-success badge ">${row.exchange_details.to_currency}</span></div>
                    </div>
                </div>
                `

              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.$router.push({name: 'transactions-detail',params: {id:row.uuid}})
          }
        },
        {
          title: 'Exchange Rate',
          valueKey: 'exchange_rate',
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${parseFloat(value).toFixed(this.amountDecimalPlaces)}</div>`
            else{
              if (row.exchange_details) {
                html = ` <div  class=" font-weight-bolder text-dark">${this.calculateProcessedAndExchangeRateAmountForList(row,true)}</div>`
              }
            }


            return  html


          }
        },
        {
          title: "Created Date / Time",
          titleHtml: `<span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: "created_at",
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${new Date(value).toISOString().slice(0, 16).replace('T', ' ')}</div>`



            return  html


          }
        },
      ],
      actions: [
        {
          title: "Charges",
          class: "btn-primary mt-1  ml-sm-50",
          cta: (row, index) => {
            this.chargesData = row
            this.showChargesModal = true
          }
        },
        {
          title: "Details",
          class: "btn-info mt-1  ml-sm-50",
          cta: (row, index) => {

            let propFilters = this.filter
            propFilters.currentPage = this.currentPage
            propFilters.tabToShow = 5

            let data = {
              index: index,
              uuid: row.uuid,
              key: "extTransactionsDetails"
            };
            this.$store.dispatch("setWithoutLocalStorage", data);
            this.$store.dispatch('triggerShowTransactionDetails', true)
          }
        },
        {
          title: "Gateway",
          class: "btn-warning mt-1  ml-sm-50",
          cta: (row, index) => {
            this.$emit('getGatewayRowData',row)
          }
        },
        {
          title: "Card",
          class: "btn-primary mt-1  ml-sm-50",
          cta: (row, index) => {
            this.transactionId = row.uuid
            this.showCardModal = true
          }
        },
        {
          title: 'Exchange',
          class: "btn-primary mt-1  ml-sm-50",
          conditionalRendering: true,
          condition: (row)=>{
            if(row.exchange_details){
              return true
            }
            return false
          },
          cta: (row) => {
            this.exchangeData = {}
            if(row.exchange_details){
              this.exchangeData = row
            }
            this.showExchangeData = true
          }
        },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{status:3},
      transactionChargesTable: {
        fetchFromApi: true,
        apiDetails:{
          url: "v1/get-transaction",
          params: {
            getParams: (row) => {
              return {
                transactionId: row.uuid,
                transactionDetail: 1
              }
            }
          },
          handleResponse: (callResponse,row,index) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let responseData = callResponse.response.data.data;
                let rawdata = this.$store.getters.getTableData(this.storageKey+'_custom')
                let rowProp = {
                  ...row,
                  accordianLoading: false,
                  charges_transactions: responseData?.charges_transactions
                }
                rawdata[index] = rowProp
                this.$store.dispatch('setTableData', { key: this.storageKey+'_custom', data: {...rawdata} })
              }
            }
          }
        },
        header: [
          {
            title: 'UUID'
          },
          {
            title: 'Receiver Account Title'
          },
          {
            title: 'Sender Account Title'
          },
          {
            title: 'Amount'
          },
        ],
        body: {
          getData: (row) => {
            let finalData = []
            let temp = []
            if(!row?.charges_transactions){
              return finalData
            }
            for (let [key, value] of Object.entries(row.charges_transactions)) {
              let temp = []
              temp.push(value.uuid)
              temp.push(value.receiver_account_title)
              temp.push(value.sender_account_title)
              temp.push(parseFloat(value.amount/100).toFixed(this.amountDecimalPlaces))
              finalData.push(temp)
            }
            return finalData
          }
        },
      },
      refundInitialAmount:''
    };
  },
  methods: {
    confirm() {
      this.confirmationModalLoader = true
      this.makeRequest("post", "v1/process-pending-transaction", {transactionId:this.transactionId,gatewaySettlementStatus:1}).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.showConfirmationModal = false
              }
            }
            this.transactionId = ''
            this.confirmationModalLoader = false
            this.showConfirmationModal = false
          }
      );

    },
    getFullResponse(response) {
      this.$emit('dataFetched',response)
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.currentPage = data.paginationData.currentPage
        delete this.filteredData.page
      }
    }
  },
  watch:{
    filter: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (val, oldVal) {
        let temp = val
        temp.status = 3
        temp.tabToShow = 5
        this.filteredData = temp
      }
    }
  }
};
</script>
